<template>
  <div>
    <VForm class="mb-5"  ref="form" v-model="isValid" @submit.prevent="popupForm" >
            <div class="d-flex justify-center align-center">
              <VCard class="popupform" style="width: 100% !important">

                <div v-if="editUser" class="d-flex flex-wrap justify-space-between">
      <div style=" font-size:18px;
    font-weight: 600;">
    Guest User
      </div>
      <div>
        <VBtn width="50%" 
                          class="but-color"
                          block
                        @click="changelogin()"
                        > login</VBtn>
        
      </div>
     </div>
                <div v-if="!editUser" @click="sendToParent()">
                  <v-btn
                  color="#1f1f45">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                </div>


                <div class="popupform_row row mt-2">
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Name</label>

                    <v-text-field
                      class="login-form"
                      v-model="formDetails.name"
                      required
                      :rules="[v => !!v || 'Please enter the value']"
                      prepend-inner-icon="mdi-account"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title title-sub">Email</label>

                    <v-text-field
                      class="login-form"
                      v-model="formDetails.email"
                      required
                      :rules="[
        v => !!v || 'Please enter your email',
        v => /.+@.+\..+/.test(v) || 'Please enter a valid email address',
      ]"
                      prepend-inner-icon="mdi-email"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Contact</label>

                    <v-text-field
                      class="login-form"
                      v-model="formDetails.number"
                      required
                      :rules="[v => !!v || 'Please enter the value']"
                      type="number"
                      prepend-inner-icon="mdi-cellphone"
                      variant="outlined"
                      length="14"
                    ></v-text-field>
                  </div>
                  <div class="row">
                    <div class="col-md-8">
                      <input type="checkbox" checked />
                      <label style="font-size: 15px" class="ms-2"
                        >Send me special offers on email or whatsApp.</label
                      >
                    </div>

                    <div class="col-md-4" >
                      <div>
                        <VBtn
                          width="50%"
                          class="but-color"
                          type="submit"
                          :disabled="goLoader"
                          block
                        >
                          <VProgressCircular
                            color="white"
                            v-if="goLoader"
                            indeterminate
                          />
                          {{ !goLoader ? "GO" : "" }}
                        </VBtn>
                      </div>
                    </div>
                  </div>
                </div>
              </VCard>
            </div>
          </VForm>
  </div>
</template>

<script >
export default{
  props:{
ediuserData: {
      type: Array,
      required: true
    },
    guestDetails: {
      type: Array,
      required: true
    },
  },
    data (){
    return{
        formDetails:{
            name:"",
            email:"",
            number:""
        },
      goLoader: false,
      shipId:"",
      editUser:false,
      isValid:false,
      
    }
},
created(){
  if(this.ediuserData){
    this.editUser=true
   this.formDetails.name = this.guestDetails.Name
    this.formDetails.email = this.guestDetails.Email
    this.formDetails.number = this.guestDetails.Contact
  }
  else{
    this.editUser=false
  }

},
methods:{
     sendToParent() {
      this.$emit("updateValue", 'shipperForm'); 
    },
    popupForm(){
      console.log('ppppppppp', this.formDetails)
      if( this.isValid){
this.goLoader=true
      this.$emit("updateformValue", this.formDetails); 
      }
      
    },

changelogin(){
  this.$emit("updateValue", 'loginFormDetails');
}
},

 
}

</script>

<style scoped>
@import "@/assets/formResponce.css";
>>>.v-field--center-affix .v-field__prepend-inner {
    padding-top: 12px !important;
}
>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
   background: none !important;
       POSITION: relative !important;
    top: -7px !important;

}
>>>.postal-form .v-field__input {
    top: -2px !important;
}
>>>.v-input__control {
    display: flex;
    grid-area: control;
    height: 40px;
}
>>>.v-field--focused .v-field__prepend-inner, .v-field--focused .v-field__append-inner {
    opacity: 1;
    height: 40px !important;
}
>>>.v-field--center-affix .v-field__prepend-inner {
    align-items: center;
    padding-top: 0 !important;
    height: 40px;
}
</style>